export default class GetResultadosC3 {
    #repository
    constructor(repository) {
        this.#repository = repository
    }
    async execute() {
        const response = await this.#repository.getAll()
        return response
    }
}
